<span mat-dialog-title>{{ 'ORDERS.CHANGE_PAYMENT_METHOD_DIALOG.TITLE' | translate }}</span>
<div class="body">
  @for (paymentMethod of data; track paymentMethod) {
  <cover-payment-method-card
    [sessionId]="c4SessionId"
    [paymentMethod]="paymentMethod"
    [adrGr]="adrGr"
    [personNr]="personNr"
    [isSelected]="paymentMethod.C4PK === paymentMethodSelected?.C4PK"
    (selectionEvent)="markAsSelected($event)"
  />
  }
</div>
<div mat-dialog-actions class="actions">
  <button mat-flat-button [mat-dialog-close]="false" color="primary">{{ 'GENERAL.CANCEL' | translate }}</button>
  <button mat-button color="primary" [disabled]="shouldDisableButton" (click)="saveChanges()">
    {{ 'GENERAL.SAVE_CHANGE' | translate }}
  </button>
</div>
